import React from 'react';

function SalaryChart() {
  const salaryData = [
    { salary: '$60,000+', timeGreen: 3, timeOrange: 37 },
    { salary: '$45,000+', timeGreen: 3, timeOrange: 27 },
    { salary: '$30,000+', timeGreen: 3, timeOrange: 17 },
    { salary: '$15,000+', timeGreen: 3, timeOrange: 7 },
  ];

  return (
    <div className="max-w-4xl mx-auto px-0 sm:px-6 py-12">
      <div className="space-y-8 relative">
        {/* Salary bars */}
        {salaryData.map((item, index) => (
          <div key={index} className="flex items-center gap-4">
            <div className="w-24 text-right font-medium text-gray-700">
              {item.salary}
            </div>
            <div className="flex-1 flex items-center h-8">
              {/* Green bar */}
              <div 
                className="h-full bg-[#98D37E]" 
                style={{ width: `${(item.timeGreen / 40) * 100}%` }}
              />
              {/* Orange bar */}
              <div 
                className="h-full bg-[#F47B54]" 
                style={{ width: `${(item.timeOrange / 40) * 100}%` }}
              />
            </div>
          </div>
        ))}
        
        {/* X-axis labels */}
        <div className="flex justify-between pl-28 text-gray-600">
          <div><span className="sm:hidden">1 Mo</span><span className="hidden sm:inline">1 Month</span></div>
          <div><span className="sm:hidden">3 Mo</span><span className="hidden sm:inline">3 Months</span></div>
          <div><span className="sm:hidden">6 Mo</span><span className="hidden sm:inline">6 Months</span></div>
          <div><span className="sm:hidden">9 Mo</span><span className="hidden sm:inline">9 Months</span></div>
          <div><span className="sm:hidden">12 Mo</span><span className="hidden sm:inline">12 Months</span></div>
        </div>
      </div>
    </div>
  );
}

export default SalaryChart;